export default "<h1>ERROR 404!</h1>\n<h2><strong>Page Not Found </strong></h2>\n<hr>\n<strong><a routerLink=\"/\">Home</a></strong>\n"